import { formatTranslation, unsafeTranslationKey } from 'intl';
import type { IntlShape } from 'react-intl';
import type { ChartSliceLabel } from '../catalog/types';

export function resolveChartLabel(
  label: ChartSliceLabel,
  intl: IntlShape
): string {
  if (typeof label === 'string') {
    return label;
  }

  return formatTranslation(intl, unsafeTranslationKey(label.labelId));
}

export function resolveChartLabels(
  labels: readonly ChartSliceLabel[],
  intl: IntlShape
): string[] {
  return labels.map((label) => resolveChartLabel(label, intl));
}

export type { ChartSliceLabel };
